import "./UnifiedPortfolioWorkspace.css";

function UnifiedPortfolioWorkspace() {
  return (
    <section className="unifiedPortfolioWorkspace">
      <header className="unifiedPortfolioWorkspace__header">
        <div>
          <p className="unifiedPortfolioWorkspace__eyebrow">
            Live portfolio
          </p>

          <h1>Portfolio</h1>

          <p>
            Only authenticated, broker-backed balances, positions, orders, and
            performance data belong on this page.
          </p>
        </div>
      </header>

      <div
        className="unifiedPortfolioWorkspace__safetyNotice"
        role="status"
      >
        Live brokerage portfolio data is not connected to this page yet. No
        sample balances, positions, profit/loss, or trade history are shown.
      </div>

      <section
        className="unifiedPortfolioWorkspace__placeholder"
        aria-labelledby="live-portfolio-status-title"
      >
        <h2 id="live-portfolio-status-title">Live portfolio status</h2>
        <p>
          Use the Trading Center for authenticated live market analysis. This
          Portfolio page will remain empty until a live brokerage account feed
          is connected and authorized for account and position data.
        </p>
      </section>
    </section>
  );
}

export default UnifiedPortfolioWorkspace;
